var _rect, _circle, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelperMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 52,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.654,
  cy: 44,
  r: 8,
  fill: "var(--hop-neutral-icon)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-strong)",
  fillRule: "evenodd",
  d: "M12.654 48c-.512 0-.928-.46-.928-1.026v-2.948c0-.567.416-1.026.928-1.026s.928.46.928 1.026v2.948c0 .567-.416 1.026-.928 1.026",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-strong)",
  d: "M11.654 41a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 127.433,
  height: 4,
  x: 28.551,
  y: 42,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})));
export default SvgHelperMessage;